import React, { useEffect, useState } from "react";
import RootLayout from "../layout";
import SpitialMoftabakh from "../../components/moftabakh/wrapper";
import httpService from "../../services/http.service";
import { getCMSApiRoute } from "../../utils/api.utils";
import _ from "lodash";

const MoftabakhPage = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  async function getCategories() {
    try {
      const response = await httpService.get(getCMSApiRoute("content"), {
        params: {
          pageIndex: 20,
          pageNumber: 1,
          category: "free",
        },
      });

      if (response.status !== 200) {
        console.log("خطا در دریافت اطلاعات", { variant: "error" });
        return [];
      } else {
        const { data } = response.data;
        return _.shuffle(data?.results);
      }
    } catch (error) {
      console.log(`Error on GET Moftabakh: ${error}`);
      console.log("خطا در دریافت اطلاعات", { variant: "error" });
      return [];
    }
  }

  useEffect(() => {
    getCategories().then((data) => {
      setData(data);
      setLoading(false);
    });
  }, []);

  return (
    <RootLayout>
      <SpitialMoftabakh data={data} loading={loading} />
    </RootLayout>
  );
};

export default MoftabakhPage;
